import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 7.5C15 11.6419 11.6419 15 7.5 15C3.35812 15 0 11.6419 0 7.5C0 3.35812 3.35812 0 7.5 0C11.6419 0 15 3.35812 15 7.5Z",
    fill: "#2196F3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.75 6.75H8.25V10.875H6.75V6.75ZM8.4375 4.6875C8.4375 5.20463 8.01713 5.625 7.5 5.625C6.98288 5.625 6.5625 5.20463 6.5625 4.6875C6.5625 4.17038 6.98288 3.75 7.5 3.75C8.01713 3.75 8.4375 4.17038 8.4375 4.6875Z",
    fill: "white"
  })
], -1)
const _hoisted_2 = {
  key: 1,
  class: "tooltip--mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tooltip", {left: $props.align === 'left', center: $props.align === 'center', right: $props.align === 'right'}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showToolTip = !$setup.showToolTip))
  }, [
    _hoisted_1,
    (!$setup.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["tooltip--text", [`text-align-${$props.textAlign}`]])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true),
    ($setup.showToolTip && $setup.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}